import React from "react";
//#region types
import { DimensionInputsContainerProps } from "models/propTypes/dimensionPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { DimensionFormTypes } from "models/formTypes";
//#endregion
//#region components
import DimensionInputs from "./dimensionInputs";
//#endregion
import * as Yup from "yup";
import { MathHelper } from "utils/helpers";

const DimensionInputsContainer: React.FC<DimensionInputsContainerProps> = (props) => {
  const formRef = React.useRef<FormHandles>(null);
  React.useEffect(() => {
    formRef.current?.validate && formRef.current.validate().catch(() => {});
  }, []);

  const onPercentageChange = (name: string, value: number) => {
    // eslint-disable-next-line eqeqeq --- disabled for now to avoid regression testing if changed
    if (value && value != props.percentage) {
      const amount = MathHelper.toFixedNoRound((props.total * value) / 100, 2);
      updateFields(amount);
    }
  };

  const onAmountChange = (name: string, value: number) => {
    // eslint-disable-next-line eqeqeq --- disabled for now to avoid regression testing if changed
    if (value && value != props.amount) {
      updateFields(value);
    }
  };

  const updateFields = (amount: number) => {
    // eslint-disable-next-line eqeqeq --- disabled for now to avoid regression testing if changed
    if (amount != props.amount) props.onChange(props.dimensionId, amount, [amount, props.total]);
  };

  return (
    <DimensionInputs
      ref={formRef}
      validationSchema={Yup.object<DimensionFormTypes.SplitInfo>({
        amount: Yup.number()
          .required(TranslationKeys.Validations.Required)
          .test("valid-amount", TranslationKeys.Validations.Required, (val) => {
            if (val == null) return false;
            // Sign-aware: a split row must be non-zero and match the total's sign
            // (negative total = refund/credit note). Zero-total keeps the old min(0).
            if (props.total === 0) return val >= 0;
            return props.total > 0 ? val > 0 : val < 0;
          }),
        percentage: Yup.number()
          .required(TranslationKeys.Validations.Required)
          .moreThan(0, TranslationKeys.Validations.Required)
          .lessThan(100.01, TranslationKeys.Validations.InvalidAmount),
      })}
      defaultValues={{
        amount: props.amount,
        percentage: props.percentage,
      }}
      currency={props.currency}
      onAmountChange={onAmountChange}
      onPercentageChange={onPercentageChange}
    />
  );
};

export default DimensionInputsContainer;
